import { Colors } from "../../../../design-tokens/colors";
import { FirePlotData } from "./fireplots";

export const formatData = (cases: FirePlotData[]) => {
  const sortedStates = cases.sort(
    (a, b) =>
      (b?.latest.averageNewCases || 0) - (a?.latest.averageNewCases || 0) ||
      (b?.latest.totalCases || 0) - (a?.latest.totalCases || 0)
  );
  const states: string[] = [];
  const dates = sortedStates.map((s) =>
    s ? new Date(s.latest.date).getTime() : new Date().getTime()
  );
  const lastDayOfWeek = new Date(Math.min(...dates)).getDay();

  let days: string[] = [];
  const columns = [];

  for (const stateCases of sortedStates) {
    const data =
      stateCases?.data?.filter(
        (d) => new Date(d.date).getDay() === lastDayOfWeek
      ) || [];

    if (data.length >= 16) {
      const cuttedData = data.slice(data.length - 16, data.length);
      if (days.length === 0) {
        days = cuttedData.map((d) => d.date).reverse();
      }
      states.push(stateCases.abbreviation);
      columns.push(cuttedData.map((d) => d.averageNewCases).reverse());
    }
  }

  return {
    states,
    days,
    columns,
  };
};

const COLOR_ARRAY = [
  "#62BF43",
  "#77C03B",
  "#91c133",
  "#f3d800",
  "#f1be05",
  "#FF9C07",
  "#FB8518",
  "#F77328",
  "#F36538",
  "#EF5C48",
  "#EB5757",
  "#DC424D", // WHITE
  "#CE2F47",
  "#C01F42",
  "#B21040",
  "#A4033F",
  "#940032",
];

export const getColorByCase = (caseCount: number) => {
  const band = caseCount > 0 ? Math.ceil(Math.log2(caseCount)) : undefined;
  const backgroundColor = band !== undefined ? COLOR_ARRAY[band] : "#6CD251";

  return {
    color: !band || band < 11 ? Colors.Black : Colors.White,
    backgroundColor,
  };
};
